export const GET_CURRENT_PAGE_INFO = 'getCurrentPageInfo'
export const GET_CURRENT_WORKSPACE = 'getCurrentWorkspace'
export const GET_CURRENT_SEARCH_AGENT = 'getCurrentSearchAgent'
export const SHOW_DELETE = 'showDelete'
export const SHOW_EDIT = 'showEdit'
